(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountDialogController', AppAccountDialogController);

    AppAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'AppAccount', 'Party', 'Document'];

    function AppAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, AppAccount, Party, Document) {
        var vm = this;

        vm.appAccount = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.parties = Party.query();
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appAccount.id !== null) {
                AppAccount.update(vm.appAccount, onSaveSuccess, onSaveError);
            } else {
                AppAccount.save(vm.appAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jmrsignApp:appAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogoImg = function ($file, appAccount) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        appAccount.logoImg = base64Data;
                        appAccount.logoImgContentType = $file.type;
                    });
                });
            }
        };

        vm.setWatermarkImg = function ($file, appAccount) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        appAccount.watermarkImg = base64Data;
                        appAccount.watermarkImgContentType = $file.type;
                    });
                });
            }
        };

    }
})();
